import { FormGroup, ValidatorFn } from '@angular/forms';

export function modifierCheckboxValidator(
  minRequired = 1,
  maxAllowed = 0,
  isPOS = false
): ValidatorFn {
  return function validate(formGroup: FormGroup) {
    let checked = 0;
    const visibleItems = formGroup.value.filter( (e) => e.isCustomerVisible === true ).length;

    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.controls[key];
      if (control.value.selected === true) {
        if(control.value.isMultiSelect) { checked=checked+control.value.selectedValue; }
        else { checked++; }
      }
    });
    if ((visibleItems >= minRequired || isPOS) && checked < minRequired) { 
      return {
        requireMoreSelectedOptions: true 
      };
    }

    if (checked > maxAllowed) {
      return {
        requireLessSelectedOptions: true
      };
    }
    return null;
  };
}
